import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  gallery: drilldownData["gallery"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
};
